import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiZap, FiArrowDown } = FiIcons;

const Hero = ({ onStartClick }) => {
  return (
    <section className="bg-white py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <SafeIcon 
              icon={FiZap} 
              className="text-3xl text-violet-600" 
              aria-hidden="true"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              Hidden Tax Calculator
            </h1>
          </div>
          
          <p className="text-xl text-gray-700 mb-4 max-w-2xl mx-auto">
            Estimate the "hidden tax" of unreliable power by calculating your generator fuel cost per kWh.
          </p>
          
          <p className="text-sm text-gray-500 mb-8">
            Educational tool only – results are estimates for decision support, not investment advice.
          </p>
          
          <motion.button
            onClick={onStartClick}
            className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white px-8 py-4 rounded-lg font-medium text-lg transition-colors focus:outline-none focus:ring-4 focus:ring-violet-200"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            aria-label="Start calculating your generator costs"
          >
            Start Calculating
            <SafeIcon icon={FiArrowDown} className="text-lg" aria-hidden="true" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;